import { useContext, useMemo, useState } from "react";
import constate from "constate";
import { SettingsContext, UserContext } from '../contexts/index.jsx';
import {
  useAddToCart,
  useCartItems,
  useRemoveOrderItem,
} from "./orderManagementApi";

const [CartProvider, useCart] = constate(() => {
  const settingsContext = useContext(SettingsContext);
  const isShopify = settingsContext?.isShopify || false;

  if (isShopify) {
    return {
      available: false,
      cartItems: [],
      count: 0,
    };
  }

  const userContext = useContext(UserContext);
  const user = userContext?.user;
  const [isVisible, setIsVisible] = useState(false);
  const { items, isLoading } = useCartItems();
  const { removeOrderItem } = useRemoveOrderItem();
  const { addToCart } = useAddToCart();
  const [refresh, setRefresh] = useState(false);

  const stats = useMemo(() => {
    const total = items.reduce((acc, item) => acc + item.price, 0);

    return { total };
  }, [items]);

  const handleAddToCart = async (listing) => {
    try {
      if (!user) {
        const items = JSON.parse(localStorage.getItem("cart")) || [];
        items.push({
          listing: { ...listing },
          listing_id: listing.id,
          quantity: 1,
        });

        localStorage.setItem("cart", JSON.stringify(items));
        setRefresh(!refresh);
      } else {
        await addToCart({
          items: [
            {
              listing_id: listing.id,
              quantity: 1,
            },
          ],
          clientId: user.id,
        });
      }
    } catch (error) {
      console.error(error);
      // TODO
    }
  };

  const removeItem = async (itemId) => {
    try {
      if (!user) {
        const prevItems = JSON.parse(localStorage.getItem("cart")) || [];
        const index = prevItems.findIndex((item) => item.listing_id === itemId);
        if (index !== -1) {
          prevItems.splice(index, 1);
          localStorage.setItem("cart", JSON.stringify(prevItems));
          setRefresh(!refresh);
        }
        await removeOrderItem(itemId);
      } else {
        await removeOrderItem(itemId);
      }
    } catch (error) {
      console.error(error);
      // TODO
    }
  };

  const realItems = useMemo(() => {
    if (user) return items;
    else return JSON.parse(localStorage.getItem("cart")) || [];
  }, [items, user, refresh]);

  return {
    available: true,
    isVisible,
    show: () => setIsVisible(true),
    hide: () => setIsVisible(false),
    toggle: () => setIsVisible((prev) => !prev),
    add: handleAddToCart,
    has: (listing) => realItems.some((item) => item.listing_id === listing.id),
    isLoading,
    removeItem,
    items: realItems,
    count: realItems?.length || 0,
    total: realItems?.reduce((acc, item) => acc + item.price, 0) || 0,
    ...stats,
  };
});

export { CartProvider, useCart };
